import { Divider, Stack } from '@mui/material';
import { isNotNullOrUndefined, ItemOf } from '@vy/utils';
import { LightInvoiceContactDetails } from '../../../../../../LightInvoiceViewPage/light-invoice-view-page-components/LightInvoiceContactDetails';
import { GetExportedIntegrationsResponse, GetLightInvoicesResponse } from '@vy/api-definition';
import { LightInvoiceViewPageActivity } from '../../../../../../LightInvoiceViewPage/light-invoice-view-page-components/LightInvoiceViewPageActivity/LightInvoiceViewPageActivity';
import { SystemEvent } from '@vy/types';
import { FC } from 'react';

type InvoiceTabProps = {
  invoice: ItemOf<GetLightInvoicesResponse['invoices']>;
  systemEvents: SystemEvent[];
  exportedInvoiceIntegrations: GetExportedIntegrationsResponse;
};

export const InvoiceTab: FC<InvoiceTabProps> = ({ invoice, systemEvents, exportedInvoiceIntegrations }) => {
  return (
    <Stack
      spacing="12px"
      sx={{
        height: 'calc(100vh - 400px)',
        overflowY: 'auto',
        scrollbarWidth: 'none',
      }}
    >
      <LightInvoiceViewPageActivity
        systemEvents={systemEvents ?? []}
        emailMessages={invoice.emailMessages ?? []}
        exportedInvoiceIntegrations={exportedInvoiceIntegrations}
      />

      <Divider />

      {isNotNullOrUndefined(invoice.contract) && (
        <LightInvoiceContactDetails
          contractName={invoice.contract.contractName}
          startDate={invoice.contract.contractStartDate}
          contractId={invoice.contract.contractId}
        />
      )}
    </Stack>
  );
};
